<app-frame [frameSrc]="url" id="NEGV"></app-frame>